'use client';

var _excluded = ["caption", "children", "className", "disabled", "onClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { useMeasure } from '@react-hookz/web';
import classNames from 'classnames';
import { MultilineEllipsis } from "../index.mjs";
import { ArrowsAngleExpand } from "../../icons/index.mjs";
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LINE_HEIGHT = 22;
var MAX_CAPTION_LINES = 3;
var CAPTION_PADDING_TOP = 16;
var CAPTION_PADDING_BOTTOM = 8;
var CAPTION_PADDING_VERTICAL = CAPTION_PADDING_BOTTOM + CAPTION_PADDING_TOP;
var IDEAL_MAX_HEIGHT = MAX_CAPTION_LINES * LINE_HEIGHT;
export function Rollover(_ref) {
  var {
      caption = '',
      children,
      className,
      disabled,
      onClick: _onClick
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var [rect, ref] = useMeasure();
  var height = (rect === null || rect === void 0 ? void 0 : rect.height) || 0;
  var captionHeight = height - CAPTION_PADDING_VERTICAL;
  var maxHeight = height > 0 ? Math.min(IDEAL_MAX_HEIGHT, captionHeight) : IDEAL_MAX_HEIGHT;
  if (disabled) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
    className: classNames('prezly-slate-image-rollover', className),
    onClick: function onClick(event) {
      event.preventDefault();
      _onClick();
    }
  }, props), {}, {
    children: /*#__PURE__*/_jsxs("span", {
      className: "prezly-slate-image-rollover__content",
      children: [children, /*#__PURE__*/_jsx("span", {
        className: "prezly-slate-image-rollover__dim"
      }), /*#__PURE__*/_jsxs("span", {
        className: classNames('prezly-slate-image-rollover__caption', {
          'prezly-slate-image-rollover__caption--empty': !caption.trim()
        }),
        children: [/*#__PURE__*/_jsx("span", {
          className: "prezly-slate-image-rollover__caption-icon-container",
          children: /*#__PURE__*/_jsx(ArrowsAngleExpand, {
            className: "prezly-slate-image-rollover__caption-icon"
          })
        }), /*#__PURE__*/_jsx("span", {
          className: "prezly-slate-image-rollover__caption-text",
          ref: ref,
          children: /*#__PURE__*/_jsx(MultilineEllipsis, {
            maxHeight: maxHeight,
            children: caption.trim()
          })
        })]
      })]
    })
  }));
}